export const SCOPE_FEATURES = {
  admin: 'Administration',
  announcements: 'Announcements',
  assets: 'Assets',
  devices: 'Device Management',
  organizations: 'Organization Management',
  pcaps: 'PCAPS',
  reports: 'Reports',
  sensor_rules: 'Sensor Rules',
  tickets: 'Tickets',
  users: 'User Management',
  downloads: 'Downloads',
  edr: 'EDR',
  logs: 'Logscale Access',
  vmp: 'VMP/VMPE',
  cases: 'Cases'
} as const;

export const INTERNAL_FEATURES = [
  'announcements',
  'assets',
  'devices',
  'pcaps',
  'sensor_rules'
];

export const PERMISSION_ACTIONS_MAP = {
  read: 'read',
  create: 'write',
  update: 'write',
  delete: 'delete'
} as const;

export const ROLE_PERMISSION_MATRIX_ABBREVIATIONS = {
  read: 'R',
  update: 'W',
  create: 'W',
  delete: 'D'
} as const;

export const ROLE_PERMISSION_COLUMN_WIDTHS = {
  account_manager: 200,
  analyst: 110,
  analytics: 130,
  announce: 130,
  rule_author: 150
};
